import { toast } from "sonner";
import { toastAndError } from "@/helpers/toast.ts";

export const clipboardWriteText = (text: string, customSuccess?: string) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success(customSuccess ?? "Copied to your clipboard!");
    })
    .catch((e) => {
      toastAndError("Unable to write to your clipboard: ", text, e);
    });
};

export const clipboardShareSession = (flowSessionGeneratorId: number) => {
  const origin = window.location.origin;
  const url = `${origin}/flow-session/${flowSessionGeneratorId}`;
  clipboardWriteText(url, "Copied session link to your clipboard!");
};

export const clipboardShareSessionMessage = (
  flowSessionGeneratorId: number,
  flowMessageId: string | number,
) => {
  const origin = window.location.origin;
  const url = `${origin}/flow-session/${flowSessionGeneratorId}?message=${flowMessageId}`;
  clipboardWriteText(url, "Copied session link and message to your clipboard!");
};
